export default __webpack_public_path__ + "static/RedHatDisplay-Black-4dd2d9a951df7e121026e696c8a70fb9.ttf";